import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  byId: {},
};

const unsavedFormsSlice = createSlice({
  name: "unsavedForms",
  initialState,
  reducers: {
    setUnsavedForm(state, action) {
      const { id, tabId, label, dirty } = action.payload || {};
      if (!id) return;

      if (!dirty) {
        delete state.byId[id];
        return;
      }

      state.byId[id] = {
        id,
        tabId: tabId || null,
        label: label || null,
      };
    },
    clearUnsavedForm(state, action) {
      delete state.byId[action.payload];
    },
    clearUnsavedForms() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("tabs/clearTabs", () => initialState)
      .addCase("auth/clearAuth", () => initialState);
  },
});

export const { setUnsavedForm, clearUnsavedForm, clearUnsavedForms } =
  unsavedFormsSlice.actions;

export default unsavedFormsSlice.reducer;
